// extracted by mini-css-extract-plugin
export default {"root":"GWiB9A","button":"q6kVwv"};